import { render } from "./keyBoardInput.vue?vue&type=template&id=121f49c6"
import script from "./keyBoardInput.vue?vue&type=script&lang=js"
export * from "./keyBoardInput.vue?vue&type=script&lang=js"

import "./keyBoardInput.vue?vue&type=style&index=0&id=121f49c6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__